import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconEndCallProps } from './IconEndCall.types'
import * as Styled from './styles/IconEndCall.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEndCall: FC<IconEndCallProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEndCallProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconEndCallProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='m18.457 15.586-2.605-1.227-.067-.035a.307.307 0 0 1-.176-.316 3.63 3.63 0 0 1 .352-1.125 6.37 6.37 0 0 1 .789-1.168.299.299 0 0 0-.043-.422.233.233 0 0 0-.05-.031 10.016 10.016 0 0 0-9.298.023.306.306 0 0 0-.125.406c.012.016.02.032.032.047.304.36.562.746.777 1.164.176.352.293.735.344 1.125a.304.304 0 0 1-.176.32l-.066.032-2.614 1.246c-.625.297-1.386.723-1.863.887 0 0-.008-.012-.016-.016a2.753 2.753 0 0 1-.64-.813c-.492-.925-.66-2.273-.172-3.171 1.23-2.274 3.613-3.586 6.058-4.399a9.988 9.988 0 0 1 6.239-.015c2.449.797 4.82 2.097 6.039 4.363.484.898.304 2.25-.192 3.176l-.402.695a.29.29 0 0 1-.375.117Zm0 0'
          fill='none'
          vectorEffect='non-scaling-stroke'
        />
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconEndCall
